import { Injectable } from "@angular/core";
import { Report, ReportService, ReportShareHistory, Status, translateCommonErrorStatus } from "@core/data";
import { Action, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";

export interface ReportShareHistoryStateModel {
    report: Report;
    status: Status;
    data: ReportShareHistory[];
}

const DEFAULTS: ReportShareHistoryStateModel = {
    report: null,
    status: Status.UNINITIALIZED,
    data: [],
}

export class InitReportShareHistory {
    static readonly type = "[ReportShareHistory] Init";
    constructor(public report: Report) {}
}

@State<ReportShareHistoryStateModel>({
    name: 'report_share_history_state',
    defaults: DEFAULTS,
})
@Injectable()
export class ReportShareHistoryState {

    constructor(
        private _reportService: ReportService,
    ) {}

    @Action(InitReportShareHistory)
    initReportShareHistory(ctx: StateContext<ReportShareHistoryStateModel>, action: InitReportShareHistory) {
        ctx.patchState({
            report: action.report,
            status: Status.LOADING,
        })

        return this._reportService.listReportShareHistory(action.report.key)
            .pipe(
                tap(
                    result => {
                        ctx.patchState({
                            status: result.length ? Status.OK : Status.EMPTY,
                            data: result,
                        })
                    },
                    error => {
                        ctx.patchState({
                            status: translateCommonErrorStatus(error),
                        });
                    }
                )
            )
    }
}